import gql from "graphql-tag";

export const signInCustomerMutation = gql`
  mutation signInCustomer(
    $phoneNumber: String!
    $pin: String
    $tabletOperationMode: TabletOperationMode
    $isMockSignIn: Boolean
  ) {
    signInCustomer(
      phoneNumber: $phoneNumber
      pin: $pin
      tabletOperationMode: $tabletOperationMode
      isMockSignIn: $isMockSignIn
    ) {
      authenticationToken
      pointsEarned
      customerDetails {
        firstName
        lastName
        email
        birthday
        phoneNumber
        pointsBalance
        interestIds
        usageTypeIds
      }
    }
  }
`;

export const signUpCustomerMutation = gql`
  mutation signUpCustomer(
    $customer: CustomerInput
    $tabletOperationMode: TabletOperationMode
  ) {
    signUpCustomer(
      customer: $customer
      tabletOperationMode: $tabletOperationMode
    ) {
      authenticationToken
      pointsEarned
      customerDetails {
        firstName
        lastName
        email
        birthday
        zipcode
        phoneNumber
        pointsBalance
        interestIds
        usageTypeIds
      }
    }
  }
`;

export const updateCustomerProfileMutation = gql`
  mutation updateCustomerProfile($customer: UpdateCustomerProfileInput) {
    updateCustomerProfile(customer: $customer) {
      id
      firstName
      lastName
      email
      zipcode
      birthday
    }
  }
`;

export const generateAndSendNewPin = gql`
  mutation generateAndSendNewPin($phoneNumber: String!) {
    generateAndSendNewPin(phoneNumber: $phoneNumber)
  }
`;

export const activateCustomerWallet = gql`
  mutation activateCustomerWallet($customerId: ID!) {
    activateCustomerWallet(customerId: $customerId) {
      tenantId
      customerId
      assetSymbol
      assetName
      accountAddress
      accountAssetBalance
    }
  }
`;

export const updatePinMutation = gql`
  mutation updatePin($authToken: String!, $newPin: String!) {
    updatePin(authToken: $authToken, newPin: $newPin)
  }
`;

export const updateCustomerInterestsAndUsageTypesMutation = gql`
  mutation updateCustomerInterestsAndUsageTypes(
    $authToken: String!
    $newInterestIds: [String]!
    $newUsageTypeIds: [String]!
  ) {
    updateCustomerInterestsAndUsageTypes(
      authToken: $authToken
      newInterestIds: $newInterestIds
      newUsageTypeIds: $newUsageTypeIds
    )
  }
`;

export const redeemPointsForReward = gql`
  mutation redeemPointsForReward(
    $authToken: String!
    $tenantEmployeePin: String!
    $rewardsAndQuantities: [RewardsAndQuantities]!
  ) {
    redeemPointsForReward(
      authToken: $authToken
      tenantEmployeePin: $tenantEmployeePin
      rewardsAndQuantities: $rewardsAndQuantities
    ) {
      pointsUsed
      updatedCustomerPointBalance
    }
  }
`;

export const recordPurchaseMutation = gql`
  mutation recordPurchase(
    $authToken: String!
    $tenantEmployeePin: String!
    $purchaseAmountDollars: Int!
    $purchaseDescriptionCategoryIds: [ID!]!
    $promoCode: String
  ) {
    recordPurchase(
      authToken: $authToken
      tenantEmployeePin: $tenantEmployeePin
      purchaseAmountDollars: $purchaseAmountDollars
      purchaseDescriptionCategoryIds: $purchaseDescriptionCategoryIds
      promoCode: $promoCode
    ) {
      pointsEarned
    }
  }
`;



// WEBPACK FOOTER //
// ./src/api/mutations.ts